export const sendErrorLog = (error: Error, context?: object) => {
  if (!window.DD_RUM) {
    return
  }

  window.DD_RUM.addError(error, context)
}
